module.exports = __webpack_public_path__ + "static/media/Message.f35cd41a.svg";